<template>
  <v-container fluid class="pa-10">
    <v-row justify="end">
      <v-col align="start">
        <v-btn
          icon
          class="hidden-xs-only"
          color="primary"
          @click="$router.push('/dashboard')"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="text-h5 text-center bold">
          ARQUIVOS PRIVADOS DO PROJETO</span
        >
        <v-row class="pt-3">
          <v-col align="start">
            <v-btn
              class="mr-2"
              fab
              small
              color="primary"
              @click="routerBackHome"
            >
              <v-icon>mdi-home</v-icon>
            </v-btn>
            <span
              v-for="(item, i) in path"
              :key="i"
              :class="i === path.length - 1 ? 'bold' : ''"
            >
              {{ i > 0 ? `> ${item.name}` : item.name }}
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        v-if="
          user.profile.id !== profiles.EDUCANDO &&
          user.profile.id !== profiles.USUARIO_EXTERNO
        "
        align="end"
        align-self="center"
        justify="center"
      >
        <v-menu>
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab large color="primary" v-bind="attrs" v-on="on">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="dialog = true">
              <v-list-item-title>Nova pasta</v-list-item-title>
            </v-list-item>

            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept="image/*"
              @change="onFileChanged"
            />

            <v-list-item @click="onButtonClick">
              <v-list-item-title>Enviar arquivo</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <v-row
      v-if="(folders && folders.length > 0) || (items && items.length > 0)"
      :gutter="25"
      class="mt-2"
    >
      <v-col
        v-if="folders && folders.length > 0"
        cols="12"
        align="start"
        class="mt-2"
      >
        <span class="text-h6 bold">Pastas</span>
      </v-col>
      <v-row v-if="folders && folders.length > 0" :gutter="25" class="mt-2">
        <v-col
          v-for="(item, i) in folders"
          :key="i"
          lg="2"
          @click="openFolder(item.id, item.name)"
        >
          <v-card outlined class="cardFile cursor">
            <v-row class="pl-3 pr-3 pt-2">
              <v-col align="end">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-if="
                        user.profile.id === profiles.ADMINISTRADOR ||
                        user.profile.id === profiles.COORDENADOR_DOCENTE ||
                        user.profile.id === profiles.COORDENADOR_DISCENTE
                      "
                      @click="openModalRenameFolder(item)"
                    >
                      <v-list-item-title>Renomear</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="user.profile.id === profiles.ADMINISTRADOR"
                      @click="removeFolder(item)"
                    >
                      <v-list-item-title>Remover</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col
                align="center"
                align-self="center"
                justify="center"
                class="pb-8"
              >
                <v-img
                  alt="Ícone correspondente a cada tipo de documento"
                  class="shrink"
                  contain
                  :src="require(`@/assets/svg/${item.icon}.svg`)"
                  :width="70"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="pl-5 pb-5 pr-5">
              <v-col align="center" align-self="center" justify="center">
                <span class="pl-2 bold">
                  {{ item.name }}
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-col
        v-if="items && items.length > 0"
        cols="12"
        align="start"
        class="mt-6"
      >
        <span class="text-h6 bold">Arquivos</span>
      </v-col>

      <v-row v-if="items && items.length > 0" :gutter="25" class="mt-2">
        <v-col
          v-for="(item, i) in items"
          :key="i"
          lg="2"
          @click="openFile(item.webViewLink)"
        >
          <v-card outlined class="cardFile cursor">
            <v-row class="pl-3 pr-3 pt-2">
              <v-col align="end">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn dark icon v-bind="attrs" v-on="on">
                      <v-icon color="black">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-if="item.webContentLink"
                      @click="openFile(item.webContentLink)"
                    >
                      <v-list-item-title>Download</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="
                        user.profile.id === profiles.ADMINISTRADOR ||
                        user.profile.id === profiles.COORDENADOR_DOCENTE ||
                        user.profile.id === profiles.COORDENADOR_DISCENTE
                      "
                      @click="openModalRenameFile(item)"
                    >
                      <v-list-item-title>Renomear</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="user.profile.id === profiles.ADMINISTRADOR"
                      @click="removeFile(item)"
                    >
                      <v-list-item-title>Remover</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col
                align="center"
                align-self="center"
                justify="center"
                class="pb-8"
              >
                <v-img
                  alt="Ícone correspondente a cada tipo de atividade"
                  class="shrink"
                  contain
                  :src="require(`@/assets/svg/${item.icon}.svg`)"
                  :width="70"
                />
              </v-col>
            </v-row>
            <v-row no-gutters class="pl-5 pb-5 pr-5">
              <v-col align="center" align-self="center" justify="center">
                <span class="pl-2 bold">
                  {{ item.name }}
                </span>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-row>

    <empty-data v-else class="mt-8" />

    <modal-box
      title="Nova Pasta"
      text-input="Nome da Pasta"
      :visible="dialog"
      @close="dialog = false"
      @save="saveFolder"
    />

    <modal-box
      ref="renomearPasta"
      title="Renomear Pasta"
      text-input="Novo Nome da Pasta"
      :visible="renomearPasta.show"
      @close="renomearPasta.show = false"
      @save="renameFolder"
    />

    <modal-box
      ref="renomearArquivo"
      title="Renomear Arquivo"
      text-input="Novo Nome do Arquivo"
      :visible="renomearArquivo.show"
      @close="renomearArquivo.show = false"
      @save="renameFileEdit"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

// eslint-disable-next-line import/no-cycle
import {
  getFiles,
  sendFile,
  sendFolder,
  renameFile,
  deleteFile,
} from '@/services/file';

import { mimeType } from '@/utils/MimeType';
import { profiles } from '@/utils/Profiles';

import EmptyData from '../components/EmptyData';
import ModalBox from '../components/ModalBox';

export default {
  name: 'Dashboard',
  components: {
    EmptyData,
    ModalBox,
  },
  data: () => ({
    profiles,
    itemsMenu: [
      { title: 'Download' },
      { title: 'Renomear' },
      { title: 'Remover' },
    ],
    items: [],
    folders: [],
    selectedFile: '',
    dialog: false,
    mimeType,
    renomearPasta: {
      show: false,
      id: '',
    },
    renomearArquivo: {
      show: false,
      id: '',
    },
    actualFolder: '',
    path: [],
  }),
  computed: {
    ...mapGetters({ user: 'user/getUser' }),
  },
  created() {
    this.getFilesAndFolders();
  },
  methods: {
    ...mapActions('loading', ['showLoading', 'hideLoading']),
    openFile(url) {
      window.open(url, '_blank');
    },
    routerBackHome() {
      this.path = [];
      this.actualFolder = '';
      this.getFilesAndFolders();
    },
    openFolder(id, name) {
      this.actualFolder = id;
      this.path.push({
        id,
        name,
      });
      this.getFilesAndFolders();
    },
    async getFilesAndFolders() {
      try {
        this.showLoading();
        const resultado = await getFiles({
          parents: this.actualFolder,
          nameContains: '',
        });

        const data = resultado.data.map((x) => {
          const icon = this.mimeType.find((z) => z.accept.includes(x.mimeType));
          return {
            ...x,
            icon: icon ? icon.svg : 'others',
          };
        });
        this.folders = data.filter((f) => f.icon === 'folder');
        this.items = data.filter((f) => f.icon !== 'folder');
      } catch (e) {
        if (this.$root.vtoast) {
          this.$root.vtoast.show({
            message: 'Erro ao buscar arquivos.',
            top: true,
            right: true,
            show: true,
            color: 'error',
          });
        }
      } finally {
        this.hideLoading();
      }
    },
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    async onFileChanged(e) {
      /* eslint-disable */
      try {
        this.showLoading();
        const formData = new FormData();
        this.selectedFile = e.target.files[0];
        formData.append('file', this.selectedFile);
        formData.append('folder', this.actualFolder);
        await sendFile(formData);

        this.$root.vtoast.show({
          message: `Arquivo ${this.selectedFile.name} adicionado com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });

        this.getFilesAndFolders();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao salvar o arquivo.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    async saveFolder(folder) {
      try {
        this.showLoading();
        const resultado = await sendFolder({
          name: folder || '',
          parent: this.actualFolder,
        });
        this.$root.vtoast.show({
          message: `Pasta ${folder} adicionada com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });
        this.dialog = false;
        this.getFilesAndFolders();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao criar a pasta.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    async renameFolder(name) {
      try {
        this.showLoading();
        const resultado = await renameFile({
          fileId: this.renomearPasta.id,
          name,
        });
        this.$root.vtoast.show({
          message: `Pasta renomeada com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });
        this.renomearPasta.show = false;
        this.renomearPasta.id = '';
        this.getFilesAndFolders();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao renomear a pasta.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    openModalRenameFolder({ id, name }) {
      this.renomearPasta.id = id;
      this.renomearPasta.show = true;
      this.$refs.renomearPasta.init(name);
    },
    async renameFileEdit(name) {
      try {
        this.showLoading();
        const resultado = await renameFile({
          fileId: this.renomearArquivo.id,
          name,
        });
        this.$root.vtoast.show({
          message: `Arquivo renomeado para ${name} com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });

        this.renomearArquivo.show = false;
        this.renomearArquivo.id = '';
        this.getFilesAndFolders();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao renomear o arquivo.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    openModalRenameFile({ id, name }) {
      this.renomearArquivo.id = id;
      this.renomearArquivo.show = true;
      this.$refs.renomearArquivo.init(name);
    },
    async removeFolder({ id }) {
      try {
        this.showLoading();
        const resultado = await deleteFile({
          filesIds: [id],
        });
        this.$root.vtoast.show({
          message: `Pasta excluída com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });
        this.getFilesAndFolders();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao excluir a pasta.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
    async removeFile({ id }) {
      try {
        this.showLoading();
        const resultado = await deleteFile({
          filesIds: [id],
        });
        this.$root.vtoast.show({
          message: `Arquivo excluído com sucesso.`,
          top: true,
          right: true,
          show: true,
          color: 'success',
        });
        this.getFilesAndFolders();
      } catch (e) {
        this.$root.vtoast.show({
          message: 'Erro ao excluir o arquivo.',
          top: true,
          right: true,
          show: true,
          color: 'error',
        });
      } finally {
        this.hideLoading();
      }
    },
  },
};
</script>

<style scoped>
.iconDash {
  font-size: 100px;
}

.cardFile {
  border-radius: 10px;
}

.bold {
  font-weight: bold;
}

.cursor {
  cursor: pointer;
}
</style>
